<template>
  <div class="container mt-5">
    <div v-if="items && items.length > 0">
      <nav aria-label="breadcrumbs" class="crumbs">
        <div class="crumbs-container">
          <span v-for="(breadcrumb, index) in items" :key="index">
            <span v-if="index < items.length - 1" class="crumb crumb-link">
              <router-link :to="breadcrumb.href">
                <span class="crumb-text">{{ breadcrumb.text }}</span>
              </router-link>
            </span>
            <span v-else class="crumb">{{ breadcrumb.text }}</span>
          </span>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'Breadcrumbs',
})
class Breadcrumbs extends Vue {
  @Prop({ type: Array, default: () => [] })
  items;
}

export default Breadcrumbs;
</script>

<style scoped lang="scss">
nav {
  margin-bottom: var(--spacing-l);
  text-align: left;
  font-family: 'KlinicSlabBold';
  font-size: 16px;
  color: #212529;
  font-weight: 400;
}

.crumbs {
  .crumbs-container {
    .crumb-link {
      display: inline;
      text-wrap: wrap;


      &::after {
        content: '>';
        margin: 0 7px;

      }

      a {
        color: #212529 !important;
        text-decoration: none;
        padding-bottom: 2px;

        &:hover,
        &:focus {
          .crumb-text::before {
            height: 100%;
            transition: height .3s ease-in-out;
          }
        }

        .crumb-text {
          position: relative;
          padding-bottom: 2px;

          &::before {
            content: '';
            position: absolute;
            bottom: 0;
            height: 2px;
            width: 100%;
            background-color: #D1D7DA;
            z-index: -1;
          }
        }
      }

      @keyframes animateBackground {
        0% {
          height: '2px';
        }

        100% {
          height: '100%';
        }
      }

    }
  }
}
</style>
